<div class="tooltip" *ngIf="ready" #tooltipBody>
    <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 22 11" class="tooltip-arrow" width="22" height="11">
        <polyline fill="#333" stroke-width="0" points="0,11 1,11 11,1 21,11 22,11" vector-effect="non-scaling-stroke"></polyline>
    </svg>
    <ng-container *ngIf="text">
        <span [innerHtml]="text"></span>
    </ng-container>
    <ng-container *ngIf="template">
        <span><ng-container *ngTemplateOutlet="template; context: {$implicit: templateContext}"></ng-container></span>
    </ng-container>
</div>
